import React, { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FaGamepad } from "react-icons/fa";
import { GiCardboardBoxClosed } from "react-icons/gi";
import { RiNetflixFill } from "react-icons/ri";
import "../styles/category.css";
import { IoIosGift } from "react-icons/io";

const CategoryLayout = ({ title, children }) => {
    const location = useLocation();

    useEffect(() => {
        document.title = title;
    }, [title]);

    return (
        <div className="product-category-container">
            <aside className="product-category-sidebar">
                <ul>
                    <li className={`sidebar-item ${location.pathname.startsWith("/category/game-account") ? "sidebar-active" : ""}`}>
                        <NavLink to="/category/game-account" className="category-navlink">
                            <FaGamepad /> Tài Khoản Game
                        </NavLink>
                    </li>
                    <li className={`sidebar-item ${location.pathname.startsWith("/category/top-up") ? "sidebar-active" : ""}`}>
                        <NavLink to="/category/top-up" className="category-navlink">
                            <GiCardboardBoxClosed /> Nạp Game Mobile
                        </NavLink>
                    </li>
                    <li className={`sidebar-item ${location.pathname.startsWith("/category/utility-account") ? "sidebar-active" : ""}`}>
                        <NavLink to="/category/utility-account" className="category-navlink">
                            <RiNetflixFill /> Tài Khoản Tiện Ích
                        </NavLink>
                    </li>
                    <li className={`sidebar-item ${location.pathname.startsWith("/category/gift-card") ? "sidebar-active" : ""}`}>
                        <NavLink to="/category/gift-card" className="category-navlink">
                            <IoIosGift /> Gift Card
                        </NavLink>
                    </li>

                </ul>
            </aside>

            <main className="category-content">
                {children}
            </main>
        </div>
    );
};

export default CategoryLayout;
